import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import ReportStore from '../../stores/ReportStore';

class PrintReportKKCReceivableCash extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,itemPerPage:20}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadData(this.state.itemPerPage)
  }

  loadData(itemPerPage) {
    
  }

  renderTable() {
     return(
      <div className=''>
        <table className='table table-responsive table-hover table-bordered-solid table-report-kkc-receivable-cash table-print-report-kkc-receivable-cash'>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center bg-none' style={{width:'50px'}}>ลำดับ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'200px'}}>เจ้าของรถ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'200px'}}>ทะเบียบรถ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'90px'}}>วันที่รับเงิน</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงินอนุมัติ<br/>เข้าซ่อม</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>ภาษี 7%</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>ก่อนรวมภาษี 7%</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>หักภาษี 3%</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>หลังหักภาษี 3%</th>
              <th className='text-center bg-none' style={{width:'100px'}}>โอนเข้าบัญชี</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>ผ่านธนาคาร</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'220px'}}>หมายเหตุ</th>
            </tr>
            <tr>
              <th className='text-center bg-none'>บาท</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td className='text-center bg-2 color-red'>รับเงินปี 2559 - 2560</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td className='text-center'>961060</td>
              <td>เงินสด</td>
              <td>บม-7886</td>
              <td className='text-center'>07/03/61</td>
              <td className='text-right'>3,500.00</td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'>3,500.00</td>
              <td className='text-center'></td>
              <td></td>
            </tr>
            <tr className='row-summary'>
              <td className='text-center bg-1'></td>
              <td className='bg-1'></td>
              <td className='bg-1'></td>
              <td className='text-center bg-1'></td>
              <td className='text-right bg-1'>3,500.00</td>
              <td className='text-right bg-1'></td>
              <td className='text-right bg-1'></td>
              <td className='text-right bg-1'></td>
              <td className='text-right bg-1'></td>
              <td className='text-right bg-1 color-red'>3,500.00</td>
              <td className='text-center bg-1'></td>
              <td className='bg-1'></td>
            </tr>
            <tr>
              <td className='text-center'>961060</td>
              <td>เงินสด</td>
              <td>บม-7886</td>
              <td className='text-center'>07/03/61</td>
              <td className='text-right'>3,500.00</td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'>3,500.00</td>
              <td className='text-center'></td>
              <td></td>
            </tr>
          </tbody>  
        </table>
      </div>
    )      
  }

  renderComponentPage() {
    return(
      <div className='font-print'>
        <header style={{textAlign:'center',marginBottom:'20px'}}>
          <h2>{this.props.title}</h2>
        </header>
        <div className='font-14'>   
          {this.renderTable()}          
        </div>
      </div>  
    )
  }

  getPagination(data,itemPerPage) {
    
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({itemPerPage:itemPerPage})
    this.loadData(itemPerPage)
  }

  render() {
    let {loading,allData} = this.state

    return(
      <PrintPreview 
        loading={loading} 
        size={'landscape'}
        leftBarTitle={this.props.title}
        defaultRowPerPage={20}
        startRowPerPage={10}
        endRowPerPage={25}
        onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
      >
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}  

PrintReportKKCReceivableCash.defaultProps = {
  title: 'รายงานสรุปรายการรับเงิน',  
  mode : '1'
}
export default PrintReportKKCReceivableCash;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportKKCReceivableCash.js